import { Component, OnInit, OnDestroy, Input, Output } from '@angular/core';
import { ESignArchiveRecord } from '../../models/esign-response.model';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { Observable, Subject, EMPTY } from 'rxjs';
import { FileDownloadItem } from 'libs/shared/documents-images/src/lib/_models';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrService as ToasterService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';
import { untilViewDestroyed } from '@sd-portal/shared/rxjs';
import { ESignCategory } from '../../models/esigncategory.model';
import { saveAs } from 'file-saver';

@Component({
  selector: 'sd-esignature-revisions',
  templateUrl: './esignature-revisions.component.html',
  styleUrls: ['./esignature-revisions.component.scss']
})
export class ESignatureRevisionsComponent implements OnInit, OnDestroy {
  @Input() archives: ESignArchiveRecord[];
  @Input() category: ESignCategory = ESignCategory.FLIGHTLOG;
  @Output() fileGuid: string;

  selectedArchiveId: number | null = null;
  isFileActionIsProgress = new Subject<boolean>();
  isFileActionIsProgress$ = this.isFileActionIsProgress.asObservable();

  constructor(private readonly http: HttpClient, private readonly toasterService: ToasterService) {}

  /* life-cycle */
  ngOnInit() {}

  ngOnDestroy(): void {
    //Destroy
  }

  archiveSelected(item: MatSelectChange) {
    if (item) {
      this.selectedArchiveId = item.value;
    } else {
      this.selectedArchiveId = null;
    }
  }

  fileRetrieveError() {
    this.isFileActionIsProgress.next(false);
    this.toasterService.error('Error retrieving file.');
  }

  previewFile() {
    if (this.selectedArchiveId) {
      this.isFileActionIsProgress.next(true);
      this.getFileDownloadItem(this.selectedArchiveId, this.category)
        .pipe(
          untilViewDestroyed(this),
          catchError(_ => {
            this.fileRetrieveError();
            return EMPTY;
          })
        )
        .subscribe(result => {
          this.isFileActionIsProgress.next(false);
          if (result.exists) {
            this.downloadDocument(result.fileId, result.contentType)
              .pipe(untilViewDestroyed(this))
              .subscribe((blob: Blob) => {
                saveAs(blob, result.fileName);
                window.open(URL.createObjectURL(blob), '_blank');
              });
          } else {
            this.toasterService.error('File could not be found.');
          }
        });
    }
  }

  downloadFile() {
    if (this.selectedArchiveId) {
      this.isFileActionIsProgress.next(true);
      this.getFileDownloadItem(this.selectedArchiveId, this.category)
        .pipe(
          untilViewDestroyed(this),
          catchError(_ => {
            this.fileRetrieveError();
            return EMPTY;
          })
        )
        .subscribe(result => {
          this.isFileActionIsProgress.next(false);
          if (result.exists) {
            this.downloadDocument(result.fileId, result.contentType)
              .pipe(untilViewDestroyed(this))
              .subscribe((blob: Blob) => {
                saveAs(blob, result.fileName);
                window.open(URL.createObjectURL(blob), '_blank');
              });
          } else {
            this.toasterService.error('File could not be found.');
          }
        });
    }
  }

  getFileDownloadItem(fileId: number, category: ESignCategory): Observable<FileDownloadItem> {
    return this.loadFileDownloadItemFromServer(fileId, category);
  }

  loadFileDownloadItemFromServer(
    fileId: number,
    category: ESignCategory
  ): Observable<FileDownloadItem> {
    let url = '';
    switch (category) {
      case ESignCategory.AIRWORTHY:
        url = `/sdapi/pre-flight/ScheduledAircraftTrip/MaintenanceDocumentSignArchive/fileDownload/${fileId}`;
        break;
      default:
        url = `/sdapi/post-flight/logbookdocument/LogbookSignArchive/fileDownload/${fileId}`;
        break;
    }

    return this.http.get<FileDownloadItem>(url);
  }

  downloadDocument(fileId: string, extension: string) {
    let url = `/sdapi/pre-flight/filestorage/DownloadDocument/${fileId}`;
    let headers = new HttpHeaders();
    headers = headers.set('Accept', `image/${extension}`);

    return this.http.get(url, { headers, responseType: 'blob' });
  }
}
